import { SectionInterface } from './Section.interface'
import { Col, Row } from 'react-bootstrap'
import { Heading, Paragraph, YouTubeEmbed } from 'src/components/atoms'
// @ts-ignore
import Fade from 'react-reveal/Fade'
import { ButtonBar } from 'src/components/molecules'
import { paragraphDef } from 'src/app-types'

const Section = ({ testID, item, imgPosition = 'left', language = 'en' }: SectionInterface) => {
    const __constructImageUrl = (url: string) => {
        return `https://cms.krewinkel.nl/${url}`
    }

    const renderImage = (additional: string) => {
        if (item.image) {
            return (
                <Col md={6} className={`item-image ${additional}`}>
                    <Fade
                        distance={'80px'}
                        duration={1500}
                        left={imgPosition === 'left'}
                        right={imgPosition === 'right'}
                    >
                        <img src={__constructImageUrl(item.image.path)} alt={item.title_en} />
                    </Fade>
                </Col>
            )
        }
        return <Col md={3} />
    }

    const renderVideo = () => {
        if (item.video_url) {
            return <YouTubeEmbed embedId={item.video_url} />
        }
    }

    return (
        <section id={`${item.slug}`} className={'Section'} data-testid={testID}>
            <Row>
                {imgPosition === 'left' && renderImage('hide-small')}
                <Col md={item.image ? 6 : 12} className={'item-content'}>
                    <Fade
                        distance={'20px'}
                        duration={800}
                        left={imgPosition === 'right'}
                        right={imgPosition === 'left'}
                    >
                        <>
                            <Heading type={'h2'} text={language === 'nl' ? item.title_nl : item.title_en} />
                            <Paragraph
                                type={paragraphDef.markdown}
                                content={language === 'nl' ? item.article_nl : item.article_en}
                            />
                            {renderVideo()}
                            {/*{item?.next && <ButtonBar nxt={item?.next} language={language} />}*/}
                        </>
                    </Fade>
                </Col>
                {renderImage('show-small')}
                {imgPosition === 'right' && renderImage('hide-small')}
            </Row>
        </section>
    )
}

export default Section
